import './recaptcha.css';

let loader = null;
let loaderKey = null;
function apiBase() {
  const store = require('@/store').default;
  return `${store.state.src}${store.state.subDirectory || ''}`.replace(/\/$/, '');
}
function timeout(work) {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => reject(new Error('人機驗證逾時，請稍後再試 / Verification timed out. Please retry.')), 15000);
    work.then(value => { clearTimeout(timer); resolve(value); }, error => { clearTimeout(timer); reject(error); });
  });
}
export async function getRecaptchaConfig() {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), 15000);
  try {
    const response = await fetch(`${apiBase()}/Recaptcha/Config`, { signal: controller.signal, cache: 'no-store' });
    if (!response.ok) throw new Error('configuration unavailable');
    const config = await response.json();
    if (typeof config.enabled !== 'boolean' || !['enterprise', 'legacy'].includes(config.provider) ||
        ((config.enabled || config.provider === 'legacy') && (typeof config.siteKey !== 'string' || !config.siteKey.trim())))
      throw new Error('invalid configuration');
    return config;
  } catch {
    throw new Error('無法取得人機驗證設定，請稍後再試 / Verification unavailable. Please retry.');
  } finally { clearTimeout(timer); }
}
function load(config) {
  const key = `${config.provider}:${config.siteKey}`;
  if (loader && loaderKey === key) return loader;
  loaderKey = key;
  document.getElementById('shared-recaptcha')?.remove();
  const script = document.createElement('script');
  script.id = 'shared-recaptcha'; script.async = true;
  script.src = `https://www.google.com/recaptcha/${config.provider === 'legacy' ? 'api' : 'enterprise'}.js?render=${encodeURIComponent(config.siteKey)}`;
  loader = timeout(new Promise((resolve, reject) => {
    script.onload = () => {
      const api = config.provider === 'legacy' ? window.grecaptcha : window.grecaptcha?.enterprise;
      if (!api) { reject(new Error('Verification could not load. Please retry.')); return; }
      api.ready(() => resolve(api));
    };
    script.onerror = () => reject(new Error('人機驗證載入失敗 / Verification could not load. Please retry.'));
    document.head.appendChild(script);
  })).catch(error => { script.remove(); loader = null; loaderKey = null; throw error; });
  return loader;
}
export async function executeRecaptcha(action) {
  const config = await getRecaptchaConfig();
  if (!config.enabled && config.provider !== 'legacy') return '';
  const token = await timeout((async () => {
    const api = await load(config);
    return api.execute(config.siteKey, { action });
  })());
  if (!token) throw new Error('人機驗證失敗 / Verification failed. Please retry.');
  return token;
}
export async function initializeRecaptcha() {
  const config = await getRecaptchaConfig();
  if (config.enabled || config.provider === 'legacy') await load(config);
}

const protectedEndpoints = {"ChachaStaffVolunteer/ValidateScheduleLogin": "web_schedule_login", "ChachaLessonPlan/ValidateLogin": "web_lesson_login", "ChachaGroupReg/Public/Create": "web_reservation_submit", "ChachaStaffVolunteer/Public/ApplyVolunteer": "web_volunteer_submit", "Frontend/SubmitForm": "web_form_submit"};
function actionFor(url, method) {
  if (!['POST', 'PUT', 'PATCH'].includes((method || 'GET').toUpperCase())) return null;
  const path = url.split('?')[0].replace(/\/$/, '').toLowerCase();
  const route = Object.keys(protectedEndpoints).find(key => path.endsWith('/' + key.toLowerCase()));
  return route ? protectedEndpoints[route] : null;
}
export async function protectedFetch(url, options = {}) {
  const action = actionFor(url, options.method);
  if (!action) return fetch(url, options);
  const token = await executeRecaptcha(action);
  return fetch(url, { ...options, headers: { ...options.headers, 'X-Recaptcha-Token': token } });
}
export async function withRecaptcha(config) {
  const action = actionFor(config.url || '', config.method);
  if (action) config.headers = { ...config.headers, 'X-Recaptcha-Token': await executeRecaptcha(action) };
  return config;
}
